import React, { useEffect } from "react";
import { getVideoByUsingSlugBasedOnUser, getVideoFromBunnyNet } from "../../../../store/features/AdminPanel/VideoTour/VideoTourApi";
import { RootStore, useAppDispatch, useAppSelector } from "../../../../store/store";
import BunnyIframe from "../../../../components/NewAcademicUser/InterviewPreparation/VideoRecord/BunnyIframe";
import WistiaPlayer from "../WistiaPlayer";
import "./index.scss";
import { getSlugByUsingUserRole } from "./getSlugByUserrole";

const VideoTourCard = () => {
  const dispatch = useAppDispatch();
  const videoTourState = useAppSelector((store: RootStore) => store.VideoTourSlice);
    const authState: any = useAppSelector((store: RootStore) => {
      return store.AuthSlice;
    });

  useEffect(() => {
    if(authState?.tac_user?.role){
      dispatch(getVideoByUsingSlugBasedOnUser({slug:getSlugByUsingUserRole(authState?.tac_user?.role)}));
    }
  }, [authState?.tac_user?.role]);

  function getWistiaVideoIdFromScript() {
    let videoId = "";
    if (videoTourState?.video_data?.content?.video_url) {
      const regex = /wistia_async_(.*?)["\s]/;
      const match = videoTourState?.video_data?.content?.video_url.match(regex);
      videoId = match ? match[1] : null;
    }
    return videoId;
  }

  function getYoutubeVideoId(url:any) {
    if (url?.includes("youtu.be")) {
      const shortUrlParts = url?.split("/");
      return shortUrlParts[shortUrlParts.length - 1];
    }
    const urlParts = url?.split(/[/=?&]/);
    const idIndex = urlParts?.findIndex((part:any) => part === "v");
    return urlParts[idIndex + 1];
  }

  return (
    <div className="tour__video__card__wrapper">
      {videoTourState?.video_data?.content?.show &&
      videoTourState?.video_data?.content?.video_status === 1 &&
      videoTourState?.video_data?.content?.videoId ? (
        <div className="video__frame__wrapper">
          <div className="video__tour__frame">
            <div className="bunny__frame__wrapper">
              <BunnyIframe videoId={videoTourState?.video_data?.content?.videoId} />
            </div>
          </div>
        </div>
      ) : (
        <div className="video__frame__wrapper">
          <div className="video__tour__frame">
            <div className="bunny__frame__wrapper">
              {videoTourState?.video_data?.content?.video_url && videoTourState?.video_data?.content?.show &&
              !videoTourState?.video_data?.content?.video_url.includes("youtu.be") && (
                <WistiaPlayer
                  videoId={getWistiaVideoIdFromScript()}
                  wrapper="wistia-wrapper"
                />
              )}
              {videoTourState?.video_data?.content?.video_url && videoTourState?.video_data?.content?.show &&
              videoTourState?.video_data?.content?.video_url.includes("youtu.be") && (
                <div style={{ position: "relative", paddingTop: "56.25%" }}>
                  <iframe
                    title={`${videoTourState?.video_data?.content?.video_url}`}
                    src={`https://www.youtube.com/embed/${getYoutubeVideoId(videoTourState?.video_data?.content?.video_url)}`}
                    loading="lazy"
                    style={{
                      border: "none",
                      position: "absolute",
                      top: 0,
                      height: "100%",
                      width: "100%",
                      borderRadius: "5px",
                    }}
                    allowFullScreen
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoTourCard;
